import { ClipboardCheck, DraftingCompass, Maximize2, ShieldCheck, Warehouse, Wrench } from "lucide-react";
import { SEO } from "../components/SEO";
import { QuoteCTA } from "../components/CTA";
import { SERVICES } from "../data/site";

const ICONS = { DraftingCompass, Warehouse, Wrench, ClipboardCheck, ShieldCheck, Maximize2 };

export default function Services() {
  return (
    <>
      <SEO title="Services | Layout & Design, Installation, Rack Audit — CustoRacks"
        description="More than rack supply: warehouse layout and design, supply and installation, dismantling and reinstallation, rack audit and stability, rack protection and storage optimisation." />
      <section className="page-hero" data-testid="services-hero">
        <div className="container">
          <div className="crumbs">Home / Services</div>
          <h1>From Design to Installation</h1>
          <p>Planning, supply, installation and ongoing support for your storage system.</p>
        </div>
      </section>
      <section className="section section-navy">
        <div className="container">
          <div className="grid-3">
            {SERVICES.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <div className="service-card" key={s.id} data-testid={`service-page-${s.id}`}>
                  <Icon size={28} />
                  <h3>{s.name}</h3>
                  <p>{s.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <QuoteCTA title="Need Help With an Existing System?" text="Dismantling, reinstallation, modification or a rack audit — tell us what you're working with." />
    </>
  );
}
